import React from 'react';
import { BaseButton } from '@repo/common';
import { ReactComponent as ArrowIcon } from '@repo/common/assets/icons/16px/icon_16px_arrow-right.svg';

const JobBoardPagination = ({
  current = 1,
  totalPages = 10,
  onPageChange,
  isMyPage,
}) => {
  const getVisiblePages = () => {
    if (current < 5) {
      return Array.from(
        { length: Math.min(10, totalPages) },
        (_, idx) => idx + 1,
      );
    } else {
      const start = current - 5;
      const end = Math.min(start + 10, totalPages);
      return Array.from({ length: end - start }, (_, idx) => start + idx + 1);
    }
  };

  const visiblePages = getVisiblePages();
  const isFirstPage = current === 1;
  const isLastPage = current === totalPages;

  const handlePrevious = () => {
    if (!isFirstPage && onPageChange) {
      onPageChange(current - 1);
    }
  };

  const handleNext = () => {
    if (!isLastPage && onPageChange) {
      onPageChange(current + 1);
    }
  };

  const handlePageClick = (page) => {
    if (onPageChange) {
      onPageChange(page);
    }
  };

  return (
    <div className='flex gap-4 items-center justify-center relative shrink-0 w-full'>
      <BaseButton
        type='text'
        size='s'
        aria-label='previous page'
        onClick={handlePrevious}
        isDisabled={isFirstPage}
        className={`h-auto min-w-0 border-0 bg-transparent hover:bg-transparent ${
          isMyPage ? 'p-1' : 'p-2'
        } rounded-lg`}
        icon={
          <ArrowIcon
            className={`size-4 rotate-180 ${
              isFirstPage
                ? 'text-grayscale-gray03 cursor-not-allowed'
                : 'text-grayscale-gray06 hover:text-grayscale-gray02'
            }`}
          />
        }
      />

      <div className='flex gap-1.5 items-center justify-center relative shrink-0'>
        {visiblePages.map((page) => {
          const isActive = page === current;
          return (
            <BaseButton
              key={page}
              type='text'
              size='s'
              hideIcon
              typo={false}
              isStatic
              onClick={() => handlePageClick(page)}
              textWrapperClass='h-auto'
              className={`min-w-0 cursor-pointer border-0 p-1.5 relative rounded-lg shrink-0 ${
                isMyPage ? 'size-[26px]' : 'size-8'
              } text-13 font-medium leading-[1.4] transition-colors ${
                isActive
                  ? 'bg-green-deep02 text-text-inverse'
                  : 'bg-transparent text-text-secondary hover:bg-grayscale-gray02'
              }`}
              aria-current={isActive ? 'page' : undefined}
            >
              {page}
            </BaseButton>
          );
        })}
      </div>

      <BaseButton
        type='text'
        size='s'
        aria-label='next page'
        onClick={handleNext}
        isDisabled={isLastPage}
        className={`h-auto min-w-0 border-0 bg-transparent hover:bg-transparent ${
          isMyPage ? 'p-1' : 'p-2'
        } rounded-lg`}
        icon={
          <ArrowIcon
            className={`size-4 ${
              isLastPage
                ? 'text-grayscale-gray03 cursor-not-allowed'
                : 'text-grayscale-gray06 hover:text-grayscale-gray05'
            }`}
          />
        }
      />
    </div>
  );
};

export default JobBoardPagination;
